var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[
  'easyscreen-badge',
  _vm.color ? `easyscreen-badge_color-${ _vm.color }` : '',
  _vm.type ? `easyscreen-badge_${ _vm.type }` : ''
]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }